import { MenuItem, Typography } from '@mui/material';
import useScreenListStyles from './styles';
import { useScreensQuery } from '@kinetic-ui/data-layer';
import { useMemo } from 'react';
import { LoadingButton } from '@qfa/react-components';
import { ScreenLayoutListProps } from './types';

const ScreenLayoutList: React.FunctionComponent<ScreenLayoutListProps> = (props) => {
  const { onScreenSelect } = props;
  const classes = useScreenListStyles(props);
  const { data, loading } = useScreensQuery();

  const screenList = useMemo(() => data?.screens || [], [data?.screens]);
  if (loading) {
    return (
      <div className={classes.screenLoading}>
        <LoadingButton loading={loading} classes={classes.loader} />
      </div>
    );
  }
  return (
    <div className={classes.screenListWrapper}>
      {screenList.map((screen, index) => (
        <MenuItem
          key={`item-${index}`}
          onClick={() => {
            onScreenSelect(screen);
          }}
          className={classes.screenMenuItem}
        >
          <div className={classes.screenLayoutItem}>
            <Typography variant='body1' className={classes.menuItemText}>
              {screen.name}
            </Typography>
          </div>
        </MenuItem>
      ))}
    </div>
  );
};

export default ScreenLayoutList;
